import { render } from "./PricingModal.vue?vue&type=template&id=2bce9940&scoped=true&lang=pug"
import script from "./PricingModal.vue?vue&type=script&lang=ts"
export * from "./PricingModal.vue?vue&type=script&lang=ts"

import "./PricingModal.vue?vue&type=style&index=0&id=2bce9940&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bce9940"

export default script